import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import SchoolIcon from '@material-ui/icons/School';
import DescriptionIcon from '@material-ui/icons/Description';
import GroupIcon from '@material-ui/icons/Group';
import { useTheme } from '@material-ui/core/styles';

const values = [
  {
    title: 'Certificado de Participación',
    description: 'Avalado por TNO Academy.',
    icon: <SchoolIcon fontSize="large" />,
  },
  {
    title: 'Guía de Escaleta Editable',
    description: 'Un recurso listo para que empieces a producir mañana mismo.',
    icon: <DescriptionIcon fontSize="large" />,
  },
  {
    title: 'Acceso a la Comunidad TNO',
    description: 'Networking directo con talentos de la planta.',
    icon: <GroupIcon fontSize="large" />,
  },
];

const ValoresAgregados = () => {
  const theme = useTheme();

  return (
    <Box>
      <Typography
        sx={{ textTransform: 'uppercase', fontWeight: 600 }}
        variant="overline"
        color="secondary"
        align="center"
        display="block"
        gutterBottom
      >
        Valores agregados
      </Typography>
      <Box
        component={Typography}
        fontWeight={700}
        variant="h5"
        gutterBottom
        align="center"
        sx={{ mb: 1 }}
      >
        Branding Academy
      </Box>
      <Grid container spacing={3}>
        {values.map((item, i) => (
          <Grid item xs={12} md={4} key={i}>
            <Box
              component={Card}
              variant="outlined"
              sx={{
                height: '100%',
                textAlign: 'center',
                transition: 'all .2s ease-in-out',
                '&:hover': { boxShadow: 2 },
              }}
            >
              <CardContent sx={{ pt: 3, pb: 3 }}>
                <Box
                  sx={{
                    width: 56,
                    height: 56,
                    borderRadius: 2,
                    bgcolor: theme.palette.primary.main + '20',
                    color: 'primary.main',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mx: 'auto',
                    mb: 2,
                  }}
                >
                  {item.icon}
                </Box>
                <Typography variant="h6" fontWeight={600} gutterBottom>
                  {item.title}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {item.description}
                </Typography>
              </CardContent>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ValoresAgregados;
